import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../axios";

export const fetchReviews = createAsyncThunk('reviews/fetchReviews', async () => {
    try {
        const { data } = await axios.get('/reviews');
        return data;
    } catch (error) {
        // Никаких запасных отзывов: придуманные отзывы с именами людей и
        // оценками — это фальшивые рекомендации, а не «заглушка на время сбоя».
        console.error("Не удалось загрузить отзывы с сервера.", error);
        return [];
    }
});

export const fetchRemoveReviews = createAsyncThunk('reviews/fetchRemoveReviews', async (id) => {
    axios.delete(`/reviews/${id}`);
});

export const fetchCreateReview = createAsyncThunk('reviews/fetchCreateReview', async (params) => {
    const { data } = await axios.post('/reviews', params);
    return data;
});

const initialState = {
    reviews: {
        items: [],
        status: 'loading'
    }
};

const reviewsSlice = createSlice({
    name: 'reviews',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchReviews.pending, (state) => {
                state.reviews.items = [];
                state.reviews.status = 'loading';
            })
            .addCase(fetchReviews.fulfilled, (state, action) => {
                state.reviews.items = action.payload;
                state.reviews.status = 'loaded';
            })
            .addCase(fetchReviews.rejected, (state) => {
                state.reviews.items = [];
                state.reviews.status = 'error';
            })
            .addCase(fetchRemoveReviews.pending, (state, action) => {
                state.reviews.items = state.reviews.items.filter(obj => obj._id !== action.meta.arg);
            })
            .addCase(fetchCreateReview.fulfilled, (state, action) => {
                state.reviews.items.unshift(action.payload);
            });
    }
});

export const reviewsReducer = reviewsSlice.reducer;
